module.exports = __webpack_public_path__ + "static/media/red_circle.6e524940.svg";